/**
 * Admin Header Component
 *
 * Header bar for admin interface with:
 * - Logo and system title on the left
 * - Administrator label
 * - User avatar, name, and optional logout on the right
 *
 * This header is designed for desktop use and appears at the top of admin pages.
 */
import React from 'react';
import './header.css';
import systemLogo from '../../../../assests/icons/system_icon.png';

export interface AdminHeaderProps {
  /** User's name to display (e.g., "木村さん") */
  userName?: string;
  /** URL for user avatar image */
  avatarUrl?: string;
  /** When set, shows a logout control next to the profile name */
  onLogout?: () => void;
}

export default function AdminHeader({ userName = '_____さん', avatarUrl, onLogout }: AdminHeaderProps) {
  return (
    <header className="admin-header">
      {/* Left section: Logo, system title, and administrator label */}
      <div className="admin-header__left">
        {/* System logo icon */}
        <img
          src={systemLogo}
          alt=""
          className="admin-header__logo"
          aria-hidden
        />
        {/* System name in Japanese: "Document+" */}
        <span className="admin-header__title">書類+</span>
        {/* Administrator label in Japanese */}
        <span className="admin-header__admin-label">管理者</span>
      </div>
      {/* Right section: User avatar, name, and logout */}
      <div className="admin-header__right">
        {/* Circular avatar container - shows user image or placeholder */}
        <div className="admin-header__avatar">
          {avatarUrl ? (
            <img src={avatarUrl} alt={userName} className="admin-header__avatar-img" />
          ) : (
            <div className="admin-header__avatar-placeholder" />
          )}
        </div>
        {/* User's name displayed next to avatar */}
        <span className="admin-header__user-name">{userName}</span>
        {onLogout ? (
          <button
            type="button"
            className="admin-header__logout-btn"
            onClick={onLogout}
          >
            ログアウト
          </button>
        ) : null}
      </div>
    </header>
  );
}
